import CookiesController from '@/controllers/cookies_controller'

export default class extends CookiesController {
  static targets = [
    'attachinary',
    'url',
    'caption',
    'captionTools',
    'enableButton',
    'disableButton',
    'disableCaption',
    'errorMessage',
  ]

  attachinaryTargetConnected(input) {
    // These events are triggered by jQuery, so we need to attach jQuery event listeners
    $(input)
      .on('attachinary:fileadded', this.#enableOrDisableButton.bind(this))
      .on(
        'attachinary:fileadded',
        this.#clickGenerateSuggestionButton.bind(this),
      )
      .on('attachinary:fileremoved', this.#enableOrDisableButton.bind(this))
  }

  connect() {
    this.#enableOrDisableButton()
  }

  disconnect() {
    this.#disconnectCable()
  }

  urlTargetConnected(input) {
    input.addEventListener('input', this.#enableOrDisableButton.bind(this))
    input.addEventListener(
      'focusout',
      this.#clickGenerateSuggestionButton.bind(this),
    )
  }

  disableButtonTargetConnected(button) {
    button.addEventListener('click', this.#disableSuggestions.bind(this))
  }

  enableButtonTargetConnected(button) {
    button.addEventListener('click', this.#generateCaption.bind(this))
  }

  #disableSuggestions() {
    this.setCookie('cesp_disable_auto_image_descriptions', 1, 365)
    this.disableCaptionTarget.classList.add('hidden')
    this.enableButtonTarget.classList.remove('hidden')
    this.errorMessageTarget.classList.add('hidden')
  }

  #enableSuggestions(_event) {
    this.deleteCookie('cesp_disable_auto_image_descriptions')
    this.enableButtonTarget.classList.add('hidden')
    this.disableCaptionTarget.classList.remove('hidden')
  }

  #clickGenerateSuggestionButton() {
    if (!this.cookiePresent('cesp_disable_auto_image_descriptions')) {
      this.enableButtonTarget.click()
    }
    this.captionToolsTarget.classList.remove('hidden')
  }

  #enableOrDisableButton() {
    this.enableButtonTarget.disabled =
      this.captionTarget.disabled || // Currently generating caption
      !(this.attachinaryTarget.disabled || this.urlTargets[0]?.value)
  }

  #generateCaption(event) {
    this.#enableSuggestions()

    this.captionTarget.disabled = true
    event.target.disabled = true

    const loadingIcon = document.createElement('div')
    loadingIcon.classList.add('loading-caption')
    loadingIcon.innerHTML =
      '<i class="far fa-sparkles"></i>&nbsp&nbsp<i class="fas fa-sync fa-spin fa-fw"></i>'
    this.captionTarget.insertAdjacentElement('afterend', loadingIcon)

    const oldCaption = this.captionTarget.value
    this.captionTarget.value = ' ' // Don't show placeholder

    const hiddenField = this.element.querySelector(
        `input[type=hidden][name='${this.attachinaryTarget.name}']`,
      ),
      requestId = crypto.randomUUID(),
      subscriptionParams = hiddenField.value
        ? {
            file: JSON.parse(hiddenField.value)[0],
            request_id: requestId,
          }
        : { path: this.urlTarget.value, request_id: requestId }

    this.#disconnectCable()
    this.subscription = this.#cable().subscriptions.create(
      {
        channel: 'Admin::ImageCaptionChannel',
        ...subscriptionParams,
      },
      {
        received: (response) =>
          this.#handleCaptionResponse(response, event, loadingIcon, oldCaption),
      },
    )
  }

  #handleCaptionResponse(response, event, loadingIcon, oldCaption) {
    const { content, status } = response

    if (status === 'starting') return

    loadingIcon.remove()

    if (status === 'error') {
      this.captionTarget.value = oldCaption
      this.errorMessageTarget.classList.remove('hidden')
    } else if (status === 'completed' && content) {
      this.captionTarget.value = content
      this.errorMessageTarget.classList.add('hidden')
      event.target.disabled = false
    }

    if (status === 'completed' || status === 'error') {
      this.captionTarget.disabled = false
      this.#disconnectCable()
    }
  }

  // This controller is registered in application_es6, so it mounts on portal pages too:
  // admin/posts/_form_layout_content is rendered by the portal's posts/new and posts/edit
  // under the parent_2col layout, and posts/_form.html+mobile.erb mounts it directly.
  // CampusESP.Admin.cable comes from the Sprockets admin bundle, which only the admin,
  // admin_flex and platform layouts include -- on a portal page the consumer created by
  // app/assets/javascripts/cable.js is the only one there is.
  #cable() {
    return CampusESP.Admin?.cable ?? CampusESP.cable
  }

  #disconnectCable() {
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
  }
}
